import { render, staticRenderFns } from "./ReviewDoctor.vue?vue&type=template&id=300cfc6a&"
import script from "./ReviewDoctor.vue?vue&type=script&lang=js&"
export * from "./ReviewDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports